import { createRoot } from 'react-dom/client';

import { App } from './App';
import { BootErrorBoundary } from '@/ui/BootErrorBoundary';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Missing #root element');
}

createRoot(root).render(
  <BootErrorBoundary>
    <App />
  </BootErrorBoundary>,
);
